import SwitchLanguageModal from './SwitchLanguageModal'

export default SwitchLanguageModal
